// Borrowed from the Site
import React from 'react';
import GA from "../../../lib/ga";

import {
    DIRECTIONS,
    imageUrl, MIN_SIMILAR_ITEMS_TO_SHOW
} from 'helpers/ApplicationHelper';

class ExtraInfoDesktopSlider extends React.Component {
    constructor(props) {
        super(props);

        this.disableTransition = false; // when changing item type and scroll carousel to initial pos should disable animation.

        this.state = {
            hiddenItemIndex: 0
        };
    }

    moveCarouselTo = (direction) => {
        const { item, version } = this.props;

        const { hiddenItemIndex } = this.state;

        this.props.logAction(`"Want to learn more" slider ${direction} arrow has been clicked`, item, version);

        if (direction === DIRECTIONS.RIGHT) {
            this.setState({ hiddenItemIndex: hiddenItemIndex + 1 })
        } else {
            this.setState({ hiddenItemIndex: this.state.hiddenItemIndex - 1 })
        }
    }

    render() {
        const { hiddenItemIndex } = this.state;
        const { slides, item, version } = this.props;
        const hasSimilarItems = item['similar_items'] && item['similar_items'].length > MIN_SIMILAR_ITEMS_TO_SHOW
        const NUM_OF_HIDDEN_SLIDES = hasSimilarItems ? 6 : 5
        const HIDDEN_FIELD_INDEX = hasSimilarItems ? 5 : 6
        /*
       * In state items added first dummy element in order to render animation for first element
       * This method calculation width from left. 25 it's cause we have 4 items per one frame in slider.
       *  hiddenItemIndex === 0 cause first element in the items is dummy.
       * */
        const calcTransformLeft = () => hiddenItemIndex === 0 ? 25 : hiddenItemIndex * ( 100 / 4 ) + 25;

        const renderArrow = (direction) => {
            const { hiddenItemIndex } = this.state;
            const isInActive = direction === DIRECTIONS.LEFT && hiddenItemIndex === 0 || direction === DIRECTIONS.RIGHT && hiddenItemIndex === NUM_OF_HIDDEN_SLIDES;


            return (
                <div
                    onClick={isInActive ? null : () => this.moveCarouselTo(direction) }
                    className={`slider-arrow ${ isInActive ? 'inactive' : 'active' }`}
                >
                    <img
                        alt=''
                        src={ imageUrl(isInActive ? 'arrow_inactive.svg' : 'arrow_active.svg') }
                        style={{
                            transform: direction === DIRECTIONS.LEFT ? 'rotate(180deg)' : 'rotate(0deg)'
                        }}
                    />
                </div>
            )
        };

        return (
            <div className={'d-flex'}>
                { renderArrow(DIRECTIONS.LEFT) }
                <div className="desktop-slider">
                    <div
                        className="slider-wrapper"
                        style={{
                            transform: `translateX(-${calcTransformLeft()}%)`,
                            transition: this.disableTransition ? 'none' : '',
                        }}
                    >
                        {
                            slides.map((slide, i) => {
                                if (slide['slug'] === 'deals' && !hasSimilarItems) {
                                    return null
                                }
                                return (
                                    <div
                                        style={{ transition: this.disableTransition ? 'none' : '', }}
                                        className={`info-slider-item ${hiddenItemIndex === i || hiddenItemIndex + HIDDEN_FIELD_INDEX === i  ? 'animate' : ''}`}
                                        key={ i }>
                                        <div
                                            key={'extra-slide' + i}
                                            className={`extra-slide extra-slide_${slide['slug']}`}
                                            onClick={() => {
                                                GA.lightListingLearnMore({title: slide['slug'] })
                                                this.props.logAction(`«${ slide['caption'] }» has been clicked`, item, version);
                                                this.props.openSlideViaParent(slide, item, version)
                                            }}>
                                            <span className={'extra-slide-caption'}>{ slide['caption'] }</span>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>

                </div>
                { renderArrow(DIRECTIONS.RIGHT) }
            </div>
        )
    }
}

export default ExtraInfoDesktopSlider;
